/**
* @file 机构名称-合规信息
* */
<template>
  <div id="organizationMessage">
    <h2 style="margin-bottom: 20px">{{ organizationName }}</h2>
    <div class="blueInfo">
      <p>* 如需开通交通运输部网约车监管信息交互平台数据接入服务，则下面的信息必须完整填写，并保证信息的真实及完整</p>
    </div>
    <el-card>
      <div name="formBasic">
        <el-row type="flex" align="middle">
          <el-col :span="22">
            <div class="formTitle" v-if="type == 1">平台公司基本信息</div>
            <div class="formTitle" v-else>平台分子公司基本信息</div>
          </el-col>
          <el-col :span="2" style="text-align: right">
            <el-button
                type="primary"
                v-show="!editBasic"
                @click="formEdit(true, 'formBasic', 'editBasic', 'basicForm')"
            >
              编辑
            </el-button>
          </el-col>
        </el-row>

        <el-form
            :model="formBasic"
            :rules="rulesBasic"
            ref="formBasic"
            :disabled="!editBasic"
            label-position="right"
            label-width="180px"
        >
          <el-row :gutter="60">
            <el-col :span="11">
              <el-form-item label="法定代表人姓名" prop="legalName">
                <el-input
                    v-model="formBasic.legalName"
                    maxlength="256"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="统一社会信用代码" prop="identifier">
                <el-input
                    v-model="formBasic.identifier"
                    maxlength="32"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="法定代表人联系电话" prop="legalPhone">
                <el-input
                    v-model="formBasic.legalPhone"
                    maxlength="32"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="注册资本金" prop="regCapital">
                <div>
                  <el-input
                      v-model="formBasic.regCapital"
                      maxlength="8"
                      style="width: 82%"
                      placeholder="请按照营业执照内容填写"
                      oninput="value=value.replace(/[^\d]/g,'')"
                  >
                  </el-input>
                  <span style="padding-left: 6px">万元</span>
                </div>

              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="法定代表人身份证号码" prop="legalId">
                <el-input v-model="formBasic.legalId" maxlength="32"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="经营业户经济类型" prop="economicType">
                <el-select v-model="formBasic.economicType">
                  <el-option label="国有全资" value="1"></el-option>
                  <el-option label="国有独资(公司)" value="2"></el-option>
                  <el-option label="私营责任有限(公司)" value="3"></el-option>
                  <el-option label="私营股份有限(公司)" value="4"></el-option>
                </el-select>
              </el-form-item>
            </el-col>


            <!--          <el-col :span="11">-->
            <!--            <el-form-item label="平台负责人姓名" prop="responsible">-->
            <!--              <el-input-->
            <!--                  v-model="formBasic.responsible"-->
            <!--                  maxlength="32"-->
            <!--              ></el-input>-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->


            <!--          <el-col :span="11">-->
            <!--            <el-form-item label="负责人联系方式" prop="responsibleWay">-->
            <!--              <el-input-->
            <!--                  v-model="formBasic.responsibleWay"-->
            <!--                  maxlength="32"-->
            <!--              ></el-input>-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->


            <!--          <el-col :span="11">-->
            <!--            <el-form-item label="平台投资人姓名" prop="investerName">-->
            <!--              <el-input-->
            <!--                  v-model="formBasic.investerName"-->
            <!--                  maxlength="32"-->
            <!--              ></el-input>-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->

            <!--          <el-col :span="11">-->
            <!--            <el-form-item label="平台投资人证件类型" prop="invidType">-->
            <!--              <el-radio v-model="formBasic.invidType" label="1"-->
            <!--              >居民身份证-->
            <!--              </el-radio-->
            <!--              >-->
            <!--              <el-radio v-model="formBasic.invidType" label="2"-->
            <!--              >统一社会信用代码-->
            <!--              </el-radio-->
            <!--              >-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->
            <!--          <el-col :span="11"></el-col>-->
            <!--          <el-col :span="11">-->
            <!--            <el-form-item label="平台投资人证件号码" prop="invidCode">-->
            <!--              <el-input v-model="formBasic.invidCode" maxlength="32"></el-input>-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->


            <!--          <el-col :span="11">-->
            <!--            <el-form-item label="平台投资人资信金额" prop="money">-->
            <!--              <el-input-->
            <!--                  v-model="formBasic.money"-->
            <!--                  maxlength="10"-->
            <!--                  oninput="value=value.replace(/[^\d]/g,'')"-->
            <!--              ></el-input>-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->


            <!--          <el-col :span="11">-->
            <!--            <el-form-item label="平台服务项目" prop="serviceItem">-->
            <!--              <el-input-->
            <!--                  v-model="formBasic.serviceItem"-->
            <!--                  maxlength="32"-->
            <!--              ></el-input>-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->


            <!--          <el-col :span="11">-->
            <!--            <el-form-item label="联系人电话" prop="contactWay">-->
            <!--              <el-input-->
            <!--                  v-model="formBasic.contactWay"-->
            <!--                  maxlength="32"-->
            <!--              ></el-input>-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->

            <!--          <el-col :span="11">-->
            <!--            <el-form-item label="质量标准和承诺" prop="servicePromise">-->
            <!--              <el-input-->
            <!--                  v-model="formBasic.servicePromise"-->
            <!--                  maxlength="32"-->
            <!--              ></el-input>-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->

            <el-col :span="11">
              <el-form-item label="公司所在省市区" prop="district">
                <el-cascader
                    filterable
                    v-model="formBasic.district"
                    :options="options"
                    @change="handleChange"
                ></el-cascader>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="行政文书送达邮寄地址" prop="mailAddress">
                <el-input
                    v-model="formBasic.mailAddress"
                    placeholder="请输入"
                ></el-input>
              </el-form-item>
            </el-col>
            <!--          <el-col :span="11">-->
            <!--            <el-form-item label="平台规范内容页面URL" prop="contractUrl">-->
            <!--              <el-input-->
            <!--                  v-model="formBasic.contractUrl"-->
            <!--                  maxlength="1000"-->
            <!--              ></el-input>-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->

            <!--          <el-col :span="11">-->
            <!--            <el-form-item label="通信地址" prop="contactAddress">-->
            <!--              <choose-address-->
            <!--                  :value.sync="formBasic.contactAddress"-->
            <!--                  :disabled="!editBasic"-->
            <!--                  placeholder="在地图上搜索位置"-->
            <!--                  @clickRowFn="clickRowFn"-->
            <!--              ></choose-address>-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->


            <el-col :span="11">
              <el-form-item label="平台紧急联系电话" prop="contactPhone">
                <el-input
                    v-model="formBasic.contactPhone"
                    maxlength="32"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="行政区划" prop="address">
                <el-input
                    v-model="formBasic.address"
                    placeholder="请先选择公司所在省市区"
                    :disabled="true"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="22">
              <el-form-item label="经营范围" prop="businessScope">
                <el-input
                    v-model="formBasic.businessScope"
                    maxlength="256"
                    placeholder="平台主体公司的经营范围"
                    type="textarea"
                ></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="11">
              <el-form-item label="法定代表人身份证附件" prop="legalPhoto">
                <div>
                  <div>
                    <up-img
                        :cut="false"
                        style="display: inline-block; vertical-align: middle"
                        :disabled="!editBasic"
                        :file.sync="formBasic.legalPhoto"
                        width="254"
                        height="160"
                    >
                    </up-img>
                  </div>
                  <div>
                   <span class="el-form-item-remark" style="vertical-align: middle"
                   >身份证正面照片</span
                   >
                  </div>
                </div>

              </el-form-item>
            </el-col>
            <el-col :span="11">
              <el-form-item label="营业执照附件" prop="identifierPhoto">
                <up-img
                    :cut="false"
                    :disabled="!editBasic"
                    :file.sync="formBasic.identifierPhoto"
                    width="254"
                    height="160"
                ></up-img>
              </el-form-item>
            </el-col>


            <!--          <el-col :span="11">-->
            <!--            <el-form-item label="邮政编码" prop="postCode">-->
            <!--              <el-input-->
            <!--                  style="width: 78%; margin-right: 20px"-->
            <!--                  v-model="formBasic.postCode"-->
            <!--                  maxlength="6"-->
            <!--                  oninput="value=value.replace(/[^\d]/g,'')"-->
            <!--              ></el-input>-->
            <!--              <a href="http://www.baidu.com" target="_blank">点击搜索</a>-->
            <!--            </el-form-item>-->
            <!--          </el-col>-->
            <!--          <el-col :span="11"></el-col>-->
          </el-row>


        </el-form>
        <div class="flex-end">
          <el-button
              v-show="editBasic"
              type="primary"
              @click="formSave('formBasic')"
              :loading="loadingBasic"
          >
            保存
          </el-button>

          <el-button
              v-show="editBasic"
              @click="formEdit(false, 'formBasic', 'editBasic', 'basicForm')"
              :loading="loadingBasic"
          >
            取消
          </el-button>
        </div>
      </div>
    </el-card>
    <div style="height: 32px"></div>

    <el-card>
      <el-row>
        <el-col :span="22">
          <div class="formTitle">网络预约出租汽车经营许可证信息</div>
        </el-col>
        <el-col :span="2" style="text-align: right">
          <el-button
              type="primary"
              v-show="!edit"
              @click="formEdit(true, 'form', 'edit', 'temporaryForm')"
          >
            编辑
          </el-button>
        </el-col>
      </el-row>

      <el-row :gutter="60">
        <el-form
            :model="form"
            :rules="rules"
            ref="form"
            :disabled="!edit"
            label-position="right"
            label-width="180px"
        >
          <el-col :span="11">
            <el-form-item label="网络车经营许可证号" prop="certificate">
              <el-input v-model="form.certificate" maxlength="64"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="发证机构名称" prop="organization">
              <el-input v-model="form.organization" maxlength="256"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="初次发证日期" prop="certifyDate">
              <el-date-picker v-model="form.certifyDate" type="date" placeholder="请选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="有效期起" prop="startDate">
              <el-date-picker v-model="form.startDate" type="date" placeholder="请选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="有效期止" prop="stopDate">
              <el-date-picker v-model="form.stopDate" type="date" placeholder="请选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="经营区域" prop="operationArea">
              <el-input v-model="form.operationArea" maxlength="128"></el-input>
            </el-form-item>
          </el-col>


        </el-form>
      </el-row>
      <div class="flex-end" v-show="edit">
        <el-button
            type="primary"
            @click="formSave('form')"
            :loading="loading"
        >
          保存
        </el-button>
        <el-button
            @click="formEdit(false, 'form', 'edit', 'temporaryForm')"
            :loading="loading"
        >
          取消
        </el-button>
      </div>

    </el-card>
    <div style="height: 32px"></div>

    <el-card v-if="type == 1">
      <div>
        <!-- 模态框 -->
        <el-dialog
            :visible.sync="payVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            @close="$refs.formPay.resetFields()"
            width="35%"
        >
          <el-row type="flex" align="middle">
            <el-col :span="22">
              <div class="formTitle" style="margin: 0 0 20px">
                {{ payTitle }}
              </div>
            </el-col>
          </el-row>

          <div class="blueInfo" style="margin: 10px 0 20px 0; width: auto">
            <p>
              * 微信支付：财付通支付科技有限公司 许可证编号Z2000444000013
              <br/>
              * 支付宝支付：支付宝(中国)网络技术有限公司 许可证编号Z2000133000019
              <br/>
              *
              备付金存管银行：微信或支付宝绑定的银行全称，建议与企业的开户行保持一致
            </p>
          </div>

          <el-form
              :model="formPay"
              :rules="rulesPay"
              ref="formPay"
              label-position="left"
              label-width="220px"
          >
            <el-form-item label="银行或者非银行支付机构名称" prop="payName">
              <el-input v-model="formPay.payName" maxlength="256"></el-input>
            </el-form-item>
            <el-form-item
                label="非银行支付机构支付业务许可证编号"
                prop="payId"
                class="white"
            >
              <el-input v-model="formPay.payId" maxlength="32"></el-input>
            </el-form-item>
            <el-form-item label="支付业务类型" prop="payType">
              <el-select v-model="formPay.payType">
                <el-option label="货币兑付" value="1"></el-option>
                <el-option label="互联网支付" value="2"></el-option>
                <el-option label="移动电话支付" value="3"></el-option>
                <el-option label="银行卡收单" value="4"></el-option>
                <el-option label="预发卡发行与受理" value="5"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务覆盖范围" prop="payScope">
              <el-input v-model="formPay.payScope" maxlength="64"></el-input>
            </el-form-item>
            <el-form-item label="备付金存管银行" prop="prepareBank">
              <el-input v-model="formPay.prepareBank" maxlength="256"></el-input>
            </el-form-item>
            <el-form-item label="结算周期" prop="countDate">
              <el-input
                  v-model="formPay.countDate"
                  maxlength="10"
                  style="width: 90%"
                  oninput="value=value.replace(/[^\d]/g,'')"
              >
              </el-input>
              <strong style="display: inline-block; width: 10%; text-align: right"
              >天
              </strong>
            </el-form-item>
          </el-form>
          <div
              slot="footer"
              class="dialog-footer"
              style="
            text-align: center;
            padding-top: 0;
            position: relative;
            top: -15px;
          "
          >
            <el-button
                type="primary"
                :loading="loadingPay"
                @click="formSave('formPay')"
            >
              保存
            </el-button>
          </div>
        </el-dialog>

        <el-row>
          <el-col :span="22">
            <div class="formTitle">平台公司支付信息</div>
          </el-col>
        </el-row>
        <el-table

            border
            empty-text="暂无数据"
            v-loading="loadingBasic"
            :data="payRows"
        >
          <el-table-column
              v-for="(item, index) in payColumns"
              :key="index"
              :show-overflow-tooltip="true"
              :prop="item.prop"
              :label="item.label"
              :width="item.width"
          >
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="100">
            <template slot-scope="scope">
              <el-button
                  @click="
                formPay = JSON.parse(JSON.stringify(scope.row));
                payVisible = true;
                payTitle = '编辑支付信息';
              "
                  type="text"
                  size="small"
              >编辑
              </el-button
              >
              <el-button type="text" size="small" @click="removePay(scope.row)"
              >删除
              </el-button
              >
            </template>
          </el-table-column>
        </el-table>
        <el-button
            v-show="payRows.length < 10"
            style="
          position: relative;
          top: 0px;
          border: 1px #dcdfe6 dashed;
          margin-top: 20px;
          padding: 10px;
          width: 100%;
        "
            @click="payAdd"
        >添加支付信息
        </el-button
        >
        <br/><br/>
      </div>
    </el-card>
  </div>
</template>

<script>
import provinceCitys from "../../../../public/provinceCitys";

export default {
  name: "organizationMessage",
  data() {
    let startDateValidator = (rule, value, callback) => {
      let stop = Date.parse(new Date(this.form.stopDate));
      value = Date.parse(new Date(value));

      if (!value) {
        callback(new Error("生效时间不能为空"));
      } else if (stop == 0) {
        callback();
        return;
      } else if (stop <= value) {
        callback(new Error("不能大于或等于到期时间"));
      } else {
        callback();
      }
    };
    let stopDateValidator = (rule, value, callback) => {
      let start = Date.parse(new Date(this.form.startDate));
      value = Date.parse(new Date(value));

      if (!value) {
        callback(new Error("到期时间不能为空"));
      } else if (start == 0) {
        callback();
        return;
      } else if (value <= start) {
        callback(new Error("不能小于或等于生效时间"));
      } else {
        callback();
      }
    };

    return {
      // 判断原本是否有内容
      id: null,
      // 机构id
      organizationId: this.$route.query.id,
      type: Number(this.$route.query.type || 0), // 编辑机构类型
      organizationName: '',
      // 基本信息表单
      // 地图搜索-默认值
      mapAddress: null,
      editBasic: false,
      options: provinceCitys[0],
      basicForm: null,
      formBasic: {},
      rulesBasic: {
        legalName: [{required: true, message: "请输入法人姓名"}],
        responsible: [{required: true, message: "请输入负责人"}],
        legalPhone: [{required: true, message: "请输入法人电话"}],
        responsibleWay: [{required: true, message: "请输入负责人联系方式"}],
        legalId: [
          {required: true, message: "请输入法人身份证号"},
          {
            pattern: /(^\d{15}$)|(^\d{17}(\d|X|x)$)/,
            message: "只能输入15-18位的身份证号",
          },
        ],
        investerName: [{required: true, message: "请输入投资人姓名"}],
        legalPhoto: [{required: true, message: "请上传法人身份证附件"}],
        invidType: [{required: true, message: "请选择投资人证件类型"}],
        invidCode: [{required: true, message: "请输入投资人证件号码"}],
        identifier: [{required: true, message: "请输入统一社会信用代码"}],
        money: [{required: true, message: "请输入投资人资信金额"}],
        regCapital: [{required: true, message: "请输入注册资本"}],
        serviceItem: [{required: true, message: "请输入服务项目"}],
        businessScope: [{required: true, message: "请输入经营范围"}],
        contactWay: [{required: true, message: "请输入联系人电话"}],
        servicePromise: [{required: true, message: "请输入质量标准和承诺"}],
        district: [{required: true, message: "请选择公司所在省市区"}],
        contractUrl: [{required: true, message: "请输入平台规范内容页面URL"}],
        contactAddress: [{required: true, message: "请输入通信地址"}],
        identifierPhoto: [{required: true, message: "请上传营业执照附件"}],
        contactPhone: [{required: true, message: "请输入紧急联系电话"}],
        address: [
          {required: true, message: "请选择公司所在省市区获取行政区划代码"},
        ],
        economicType: [{required: true, message: "请选择经营业户经济类型"}],
        postCode: [
          {required: true, message: "请填写邮政编码"},
          {
            pattern: /^[1-9][0-9]{5}$/,
            message: "请检查邮政编码是否正确",
          },
        ],
        mailAddress: [{required: true, message: "请输入"}],
      },


      form: {},
      rules: {
        responsibleName: [{required: true, message: "负责人姓名"}],
        responsiblePhone: [{required: true, message: "请输入负责人电话"}],
        managerName: [{required: true, message: "请输入管理人姓名"}],
        managerPhone: [{required: true, message: "请输入管理人电话"}],
        detailAddress: [{required: true, message: "请输入详细地址"}],
        district: [{required: true, message: "请选择省市区"}],
        address: [{required: true, message: "请选择省市区获取行政区划代码"}],
        serviceNo: [{required: true, message: "请输入统一社会信用代码"}],
        contactPhone: [
          {required: true, message: "请输入机构名称紧急联系电话"},
        ],
        mailAddress: [
          {required: true, message: "请输入行政文书送达邮寄地址"},
        ],
        certificate: [
          {required: true, message: "请输入网络预约出租汽车经营许可证号"},
        ],
        organization: [{required: true, message: "请输入发证机构名称"}],
        operationArea: [{required: true, message: "请输入经营区域"}],
        certifyDate: [{required: true, message: "请选择初次发证日期"}],
        startDate: [{required: true, validator: startDateValidator}],
        stopDate: [{required: true, validator: stopDateValidator}],
      },
      // 平台公司支付信息
      payVisible: false,
      payTitle: "添加支付信息",
      formPay: {},
      rulesPay: {
        payName: [
          {required: true, message: "请输入银行或者非银行支付机构名称"},
        ],
        payId: [
          {required: true, message: "请输入非银行支付机构支付业务许可证编号"},
        ],
        payType: [{required: true, message: "请选择支付业务类型"}],
        payScope: [{required: true, message: "请输入业务覆盖范围"}],
        prepareBank: [{required: true, message: "请输入备付金存管银行"}],
        countDate: [{required: true, message: "请输入结算周期"}],
      },
      edit: false,
      payColumns: [
        {
          prop: "payName",
          label: "银行或者非银行支付机构名称",
          width: 200,
        },
        {
          prop: "payId",
          label: "非银行支付机构支付业务许可证编号",
          width: 240,
        },
        {prop: "payTypeName", label: "支付业务类型", width: 120},
        {prop: "payScope", label: "业务覆盖范围"},
        {prop: "prepareBank", label: "备付金存管银行", width: 120},
        {prop: "countDate", label: "结算周期", width: 100},
      ],
      payRows: [],
      // 保存按钮loading
      loadingBasic: false,
      loadingPay: false,
      loading: false,
    };
  },
  methods: {
    async clickRowFn(res) {
      this.$set(this.formBasic, "contactAddress", res.address + " " + res.name);
      this.formBasic.longitude = res.location.lng;
      this.formBasic.latitude = res.location.lat;
    },
    handleChange(value) {
      if (value && value.length > 0) {
        this.$set(this.formBasic, "district", value);
        this.$set(this.formBasic, "address", value[value.length - 1]);
      }
    },
    // type:编辑或者取消 formName:表单form editNumber:编辑下标 temporaryForm:临时form对象
    formEdit(type, formName, editNumber, temporaryForm) {
      if (type) {
        this[temporaryForm] = JSON.parse(JSON.stringify(this[formName]));
        this[editNumber] = true;
      } else {
        this.$refs[formName].resetFields();
        this[formName] = JSON.parse(JSON.stringify(this[temporaryForm]));
        this[editNumber] = false;
      }
    },
    // 添加平台公司支付信息事件
    payAdd() {
      if (!this.id) {
        this.$message.warning(
            "请先完善【平台公司基本信息】并保存后，再进行操作"
        );
      } else {
        this.payTitle = "添加支付信息";
        this.payVisible = true;
      }
    },
    /**
     * 点击保存
     */
    async formSave(formName) {
      switch (formName) {
        case "formBasic":
          this.$refs.formBasic.validate((valid) => {
            if (valid) {
              this.postFn();
            } else {
              this.$message.warning("请检查表单数据是否输入正确！");
            }
          });
          break;
        case "formPay":
          this.$refs.formPay.validate((valid) => {
            if (valid) {
              this.postPay();
            } else {
              this.$message.warning("请检查表单数据是否输入正确！");
            }
          });

          break;
        case "form":
          this.$refs.form.validate((valid) => {
            if (valid) {
              this.postFnForm();
            } else {
              this.$message.warning("请检查表单数据是否输入正确！");
            }
          });
          break;
        default:
          break;
      }
    },
    async postFnForm() {
      this.loading = true;
      let url = "/api/v1/manage/organization/supervise/company";
      let params = this.$utils.deepCopyFn({
        ...this.form,
        certifyDate: Date.parse(new Date(this.form.certifyDate)),
        startDate: Date.parse(new Date(this.form.startDate)),
        stopDate: Date.parse(new Date(this.form.stopDate)),
      });

      if (!params.organizationId) {
        params.organizationId = this.organizationId;
      }
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.edit = false;
        this.getOnlineBook();
      }
      this.loading = false;
    },
    /**
     * 接口请求-基本信息保存
     */
    async postFn() {
      this.loadingBasic = true;
      let url = "/api/v1/manage/organization/supervise/platform";
      let data = JSON.parse(JSON.stringify(this.formBasic));
      if (data.district.length == 2) {
        data.city = data.district[0];
        data.district = data.district[1];
      } else if (data.district.length == 3) {
        data.province = data.district[0];
        data.city = data.district[1];
        data.district = data.district[2];
      }
      if (!data.organizationId) {
        data.organizationId = this.organizationId;
      }
      let res = await this.$axios.post(url, data);
      if (res && res.code === 1) {
        this.$message.success("保存成功！");
        this.editBasic = false;
        this.getPlatform();
      }
      this.loadingBasic = false;
    },

    /**
     * 接口请求-平台公司支付信息保存
     */
    async postPay() {
      this.loadingPay = true;
      let url = "/api/v1/manage/organization/supervise/platform/pay";
      this.formPay.organizationId = this.organizationId;
      let params = this.$utils.deepCopyFn(this.formPay);
      let data = await this.$axios.post(url, params);
      if (data && data.code === 1) {
        this.$message.success("保存成功！");
        this.payVisible = false;
        this.getPayRows();
      }
      this.loadingPay = false;
    },

    //删除平台公司支付信息
    async removePay(row) {
      let payURL =
          "/api/v1/manage/organization/supervise/platform/pay/" + row.id;
      let res = await this.$axios.delete(payURL);
      if (res && res.code === 1) {
        this.$message.success("已删除");
        this.getPayRows();
      }
    },

    /**
     * 获取总公司详情
     */
    async getInfo() {
      this.getPlatform();

      console.log(typeof this.type, 1212)
      this.type === 1 && this.getPayRows();
      this.getOnlineBook();
    },
    async getPlatform() {
      let formBasicURL =
          "/api/v1/manage/organization/supervise/platform/" + this.organizationId;
      let data = await this.$axios.get(formBasicURL);
      if (data && data.code === 1) {
        this.id = data.data.id || null;
        this.formBasic = data.data || {};
        this.organizationName = await this.getOrgName(this.organizationId)
        if (data.data.province) {
          data.district = [
            data.data.province,
            data.data.city,
            data.data.district,
          ];
        } else {
          data.district = [data.data.city, data.data.district];
        }

        this.$refs.formBasic.clearValidate();
      }
    },
    //获取平台公司支付信息列表
    async getPayRows() {
      let payURL =
          "/api/v1/manage/organization/supervise/platform/pay?organizationId=" +
          this.organizationId;
      let res = await this.$axios.get(payURL);
      if (res && res.code === 1) {
        res.data.forEach((item) => {
          item.payTypeName = new Map([
            ["1", "货币兑付"],
            ["2", "互联网支付"],
            ["3", "移动电话支付"],
            ["4", "银行卡收单"],
            ["5", "预发卡发行与受理"],
          ]).get(item.payType);
        });
        this.payRows = res.data || [];
      }
    },

    async getOnlineBook() {
      if (!this.organizationId) {
        return false;
      }
      let formURL =
          "/api/v1/manage/organization/supervise/company/" + this.organizationId;
      let data = await this.$axios.get(formURL);
      if (data && data.code === 1) {
        this.organizationName = await this.getOrgName(this.organizationId)
        if (data.data.province) {
          data.district = [
            data.data.province,
            data.data.city,
            data.data.district,
          ];
        } else {
          data.district = [data.data.city, data.data.district];
        }
        this.form = data.data || {};
        this.$refs.form.resetFields();
      }
    }
  },
  async created() {
    await this.getInfo();
  },
  watch: {
    payVisible(val) {
      if (!val) {
        this.formPay = {};
      }
    },
  },
};
</script>

<style lang="less">
#organizationMessage {
  padding: 20px 40px;
  max-width: 1200px;

  h2 {
    font-size: 18px;
    font-weight: 600;
    color: #303133;
    margin-bottom: 16px;
  }

  .blueInfo {
    margin-bottom: 20px;
  }

  .el-card {
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    
    .el-card__body {
      padding: 20px 24px;
    }
  }

  .formTitle {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    padding-bottom: 12px;
    border-bottom: 1px solid #ebeef5;
    margin-bottom: 20px;
  }

  .el-form {
    .el-form-item {
      margin-bottom: 18px;
      
      .el-form-item__label {
        color: #606266;
        font-weight: 500;
      }
    }
    
    .el-input__inner,
    .el-select .el-input__inner,
    .el-cascader .el-input__inner {
      border-radius: 6px;
    }
    
    .el-date-editor {
      width: 100%;
      
      .el-input__inner {
        height: 32px;
        line-height: 32px;
      }
    }
    
    .el-textarea__inner {
      height: 80px;
      border-radius: 6px;
    }
  }

  .flex-end {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
    padding-top: 16px;
    border-top: 1px solid #ebeef5;
    margin-top: 20px;
  }

  .el-button {
    border-radius: 6px;
    min-width: 80px;
  }

  .el-table {
    border-radius: 8px;
    
    th {
      background: #f5f7fa;
    }
  }

  .first-level {
    display: block;
  }

  .second-level {
    padding-left: 24px;
  }

  // 禁用状态样式增强
  .el-form.is-disabled,
  .el-form[disabled] {
    .el-input__inner,
    .el-textarea__inner,
    .el-select .el-input__inner {
      background: #f5f7fa;
      color: #909399;
    }
  }
}
</style>
